import React from 'react';
import '../App.css';
import breathworkImage from '../assets/breathwork.jpeg';
import BreathworkSwiper from '../components/BreathworkSwiper';
import { FaCheck } from "react-icons/fa";
import Stripes from '../components/Stripes';
import calisthenicBg from '../assets/bg.jpg'
import Signup from '../components/Signup';
import Footer from '../components/Footer';

const Breathwork = () => {
  return (
    <div className="breathwork-page">
      {/* Hero Section */}
      <div
        className="breathwork-banner"
        style={{ backgroundImage: `url(${breathworkImage})` }}
      >
        {/* Dark overlay */}
        <div className="banner-overlay"></div>

        <h2>BREATHWORK</h2>
      </div>

     {/* Content Section */}
      <div className="breathwork-content">
        <h3>What Is Breathwork?</h3>
        <p>
         Breathwork is the intentional practice of controlling your breathing patterns to influence your physiology, mindset, and energy. It’s more than “just breathing”, it's a tool you can use to calm your nervous system, sharpen focus, recover faster, and unlock deeper states of presence.
        </p>
        <p>
         When we breathe well, everything downstream (movement, recovery, stress, sleep) improves.
        </p>
      </div>
      <BreathworkSwiper/>
    <div className="reasons-section container mt-5">
         <h3 className="coach">
           WHY I INCLUDE  <br /> BREATHWORK IN MY <br />COACHING
         </h3>
   
         {/* TOP 3 ITEMS */}
         <div className="parent">
           <div className="reason-box">
             <div className="check">
               <FaCheck className="check-mark" />
             </div>
             <p className="calistehenic-h">
              Stress resilience & recovery
             </p>
             <p className="calistehenic-p">
              Learning to use your breath can help you bounce back from tough training, tight schedules, or daily stress.
             </p>
           </div>
   
           <div className="reason-box">
             <div className="check">
               <FaCheck className="check-mark" />
             </div>
             <p className="calistehenic-h">Better movement & control</p>
             <p className="calistehenic-p">
              Good breathing helps you maintain tension, stabilize your core, and move more efficiently.
             </p>
           </div>
   
           <div className="reason-box">
             <div className="check">
               <FaCheck className="check-mark" />
             </div>
             <p className="calistehenic-h">Mind–body connection</p>
             <p className="calistehenic-p">
               Breath is a bridge between the conscious and subconscious: train it, and you tap into flow, calm, or intensity on demand.
             </p>
           </div>
         </div>
   
         {/* BOTTOM 2 ITEMS */}
         <div className="calisthenics mt-4">
           <div className="reason-box">
             <div className="check-marks">
               <FaCheck className="check-mark" />
             </div>
             <p className="calistehenic-h">Sleep & regulation</p>
             <p className="calistehenic-p">
               Breathwork tools can lower heart rate, shift you into parasympathetic states, and improve sleep quality.
             </p>
           </div>
   
           <div className="reason-box">
             <div className="check-marks">
               <FaCheck className="check-mark" />
             </div>
             <p className="calistehenic-h">Scalable & portable</p>
             <p className="calistehenic-p">
              You don’t need gear, you can do breathwork anywhere, anytime.
             </p>
           </div>
         </div>
       </div>
<Stripes/>
<div className="who-section">
  <img src={calisthenicBg} alt="Background" className="who-bg" />
  <div className="who-overlay"></div>

  <div className="who-content container text-center">
    <h2 className="coach">WHO THIS IS FOR</h2>

    <p className="calisthenic-p">
      You want to <span className="bold">calm your mind, reduce stress, and sleep better</span>
    </p>
    <p className="calisthenic-p">
      You’re driven to <span className="bold">improve performance, control, and movement fluency</span> 
    </p>
    <p className="calisthenic-p">
     You feel “off balance,” anxious, or fatigued often
    </p>
    <p className="calisthenic-p">
      You want tools you can carry with you, no gym needed
    </p>
    <p className="calisthenic-p">
    You believe in <span className="bold">holistic training</span>, body, mind, breath
    </p>
  </div>
</div>

  <div className="container mt-5 d-sm-block d-none">
        <h3 className="coach">
          WHAT YOU CAN EXPECT OVER TIME
        </h3>

        <p className="calisthentic-p mb-5">
          I don’t teach “one-size-fits-all” techniques. Every breath cue,
          protocol, and progression is adjusted to your nervous system, history,
          and goals. I’ll walk you through each pattern, listen to your feedback,
          and adjust so breathing becomes a tool you own.
        </p>
      </div>
      <div className="container mt-3 week-section">
  <div className="row">
    <div className="col-lg-3 col-6">
      <h6 className="weeks">WEEK 1–2</h6>
      <p className="progres">Better awareness of breath, deeper diaphragmatic patterns, some calming effects</p>
    </div>

    <div className="col-lg-3 col-6">
      <h6 className="weeks">WEEK 3–4</h6>
      <p className="progres">More control, ability to use breathing in movement, better recovery after sessions</p>
    </div>

    <div className="col-lg-3 col-6">
      <h6 className="weeks">MONTH 2–3</h6>
      <p className="progres">Noticeable improvements in stress resilience, sleep, recovery, mental clarity</p>
    </div>

    <div className="col-lg-3 col-6">
      <h6 className="weeks">ONGOING</h6>
      <p className="progres">Breath becomes an integrated tool—calm, intensity, control, on demand</p>
    </div>
  </div>
</div>
<Signup/>
<Footer/>
</div>

    
  );
};

export default Breathwork;
